import { render, staticRenderFns } from "./CreatePotSize.vue?vue&type=template&id=000478cf&"
import script from "./CreatePotSize.vue?vue&type=script&lang=js&"
export * from "./CreatePotSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports